const CancelablePromise = require('mn-utils/CancelablePromise');
const param = require('mn-utils/param');
const IBAN_CACHE = {};

function requestGet(url, params) {
  return CancelablePromise.resolve(fetch(url + '?' + param(params), {
    method: 'GET',
    mode: 'cors',
    cache: 'no-cache',
  })).then((response) => {
    const {
      status,
    } = response;
    return response.json().catch((e) => {
      throw status > 199 && status < 400
        ? e
        : new Error('HTTP status: ' + status);
    });
  });
}

export function apiIbansGet(params) {
  const {
    iban,
  } = params;
  return (
    IBAN_CACHE[iban] || (IBAN_CACHE[iban] = requestGet(
        'https://openiban.com/validate/' + iban,
        {
          validateBankCode: true, // (not guaranteed)
          getBIC: true, // (not guaranteed)
        },
    )
        .finally((error) => {
          if (error) {
            console.error(error);
            delete IBAN_CACHE[iban];
          }
        })
    )
  );
}
